import { render, staticRenderFns } from "./DocumentChartReview.vue?vue&type=template&id=00d300cd&"
import script from "./DocumentChartReview.vue?vue&type=script&lang=js&"
export * from "./DocumentChartReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports